export default "__VITE_ASSET__CpJKqXh9__"